export const __TermsLang = {
    title: 'شرایط و قوانین',
};
